import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/lib/integration/react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {ProvideAuth, useAuth} from './services/authServices';
import {persistor, store} from './redux/reducers';
import Start from './pages/Start';
import MainPage from './pages/MainPage';
import MainNavBar from './components/MainNavBar';
import Footer from './components/Footer';
import ReactGA from "react-ga4";
import Cookie from "cookie";

import {PopupDialogProvider} from './components/PopupDialog';

import './services/i18n';

import './App.less';

function App(props) {
    useEffect(() => {
        ReactGA.initialize(window.location.host === "landlord.inlifehousing.com" ? "GTM-P3VFXDDH" : "G-SGQ8V16BHH");
        const _i = setInterval(() => {
            const cookies = Cookie.parse(document.cookie);
            if (cookies["_ga"]) {
                let _ga = cookies["_ga"].split(".");
                //console.log("GA initialized", cookies["_ga"]);
                ReactGA.set({userId: _ga[2]});
                ReactGA.set({user_id: _ga[2]});
                clearInterval(_i);
            }
        }, 500);

    }, [])

    // useEffect(() => {
    //     console.log("cookies!", document.cookie);
    // }, [document.cookie])

    return (
        <ProvideAuth>
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <Router>
                        <PopupDialogProvider>
                            <MainNavBar/>
                            <Switch>
                                <Route path="/start" component={Start}/>
                                <Route path="/" component={MainPage}/>
                                <Redirect to={'/start/login'}/>
                            </Switch>
                        </PopupDialogProvider>
                    </Router>
                    <Footer/>
                    {/*<FooterNew displayApp={false}/>*/}
                </PersistGate>
            </Provider>
        </ProvideAuth>

    );
}

export default App;
